import { useEffect, useRef } from "react";
import { useIntercom } from "react-use-intercom";
import { useSelector } from "react-redux";
import { RootState } from "../redux/reducers";
import { selectAuthDetails } from "../redux/selectors";

export default function IntercomManager() {
  const { boot, shutdown } = useIntercom();
  const { user, user_hash_token } = useSelector((state: RootState) =>
    selectAuthDetails(state)
  );
  const hasBooted = useRef(false);

  useEffect(() => {
    if (user && user_hash_token && !hasBooted.current) {
      hasBooted.current = true;
      console.log("Booting Intercom...");

      boot({
        intercomUserJwt: user_hash_token, // 🔐 secure mode JWT
        // userId: user.patient_id?.toString(),
        // name: `${user.patient_first_name} ${user.patient_last_name}`,
        // email: user.patient_email,
        // createdAt: Math.floor(Date.now() / 1000),
        // any custom attributes...
      });
    } else if (!user && hasBooted.current) {
      console.log("Shutting down Intercom...");
      hasBooted.current = false;
      shutdown();
    }
  }, [user, boot, shutdown, user_hash_token]);

  return null; // no UI, just global control
}
